import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Button, Image } from '@outdoor-voices/ui';
import PropTypes from 'prop-types';
import React, { memo, useContext } from 'react';
import { OVContext } from '../../utils/OVContext';
import { parseMarkdown } from '../product/Tabs/utils';
import css from './Overview.module.scss';
import Price from '../../components/Price';
import Video from '../../components/Video';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Overview = /*#__PURE__*/memo(function (_ref) {
  var cta = _ref.cta,
      kit = _ref.kit,
      onClick = _ref.onClick;
  var compareAtPrice = kit.compareAtPrice,
      description = kit.description,
      image = kit.image,
      imageMobile = kit.imageMobile,
      price = kit.price,
      subtitle = kit.subtitle,
      title = kit.title,
      video = kit.video,
      videoMobile = kit.videoMobile;

  var _useContext = useContext(OVContext),
      mobileLarge = _useContext.mobileLarge;

  var ctaProps = onClick ? {
    onClick: onClick
  } : {
    href: kit.absoluteUrl
  };
  return /*#__PURE__*/_jsxs("div", {
    className: css.root,
    children: [/*#__PURE__*/_jsxs("div", {
      className: css.image,
      children: [!mobileLarge && video && /*#__PURE__*/_jsx("div", {
        style: {
          aspectRatio: "".concat(video.poster.width, " / ").concat(video.poster.height)
        },
        children: /*#__PURE__*/_jsx(Video, _objectSpread(_objectSpread({}, video), {}, {
          autoPlay: true,
          controls: false,
          controlsList: "nodownload",
          crossOrigin: "anonymous",
          muted: true,
          poster: video.poster.src,
          preload: "metadata",
          src: video.src,
          track: {
            src: video.subtitleUrl
          }
        }))
      }), mobileLarge && videoMobile && /*#__PURE__*/_jsx(Video, _objectSpread(_objectSpread({}, videoMobile), {}, {
        autoPlay: true,
        controls: false,
        controlsList: "nodownload",
        crossOrigin: "anonymous",
        muted: true,
        poster: videoMobile.poster.src,
        preload: "metadata",
        src: videoMobile.src,
        track: {
          src: videoMobile.subtitleUrl
        }
      })), !mobileLarge && !video && /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, image), {}, {
        alt: title,
        sizes: [320, 400, 700]
      })), mobileLarge && !video && /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, imageMobile), {}, {
        alt: title,
        sizes: [320, 400]
      }))]
    }), /*#__PURE__*/_jsxs("div", {
      className: css.text,
      children: [subtitle && /*#__PURE__*/_jsx("div", {
        className: css.subtitle,
        children: subtitle
      }), onClick ? /*#__PURE__*/_jsx("div", {
        className: css.title,
        children: title
      }) : /*#__PURE__*/_jsx("a", {
        className: css.title,
        href: kit.absoluteUrl,
        children: title
      }), price > 0 && /*#__PURE__*/_jsxs("div", {
        className: css.price,
        children: [/*#__PURE__*/_jsx(Price, {
          compareAtPrice: compareAtPrice
        }), " ", /*#__PURE__*/_jsx(Price, {
          price: price
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: css.description,
        dangerouslySetInnerHTML: {
          __html: parseMarkdown(description)
        }
      }), cta && /*#__PURE__*/_jsx("div", {
        className: css.cta,
        children: /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({}, ctaProps), {}, {
          ariaLabel: "Navigate to build ".concat(title),
          big: true,
          children: cta
        }))
      })]
    })]
  });
});
var VideoType = PropTypes.shape({
  src: PropTypes.string,
  subtitleUrl: PropTypes.string,
  poster: PropTypes.shape({
    alt: PropTypes.string,
    src: PropTypes.string,
    height: PropTypes.number,
    width: PropTypes.number
  })
});
Overview.propTypes = {
  cta: PropTypes.string,
  kit: PropTypes.shape({
    absoluteUrl: PropTypes.string,
    compareAtPrice: PropTypes.number,
    cta: PropTypes.string,
    description: PropTypes.string,
    image: PropTypes.shape({}),
    imageMobile: PropTypes.shape({}),
    price: PropTypes.number,
    subtitle: PropTypes.string,
    title: PropTypes.string,
    video: VideoType,
    videoMobile: VideoType
  }),
  onClick: PropTypes.func
};